const state = {
    routes: [],
    isFrameworkRoutedLoaded: false
}
const mutations = {
    SET_ROUTES: (state, routes) => {
        state.routes = routes
    },
    SET_FRAMEWORK_ROUTE_LOADED: (state) => {
        state.isFrameworkRoutedLoaded = true
    }
}
const actions = {
    /**
     * 保存路由信息
     * @param {} param0 
     * @param {*} routes 
     */
    cacheRoutes({ commit }, routes) {
        commit('SET_ROUTES', routes);
    },
    frameworkRoutesLoaded({ commit }) {
        commit('SET_FRAMEWORK_ROUTE_LOADED');
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}